import React from 'react'
import "../About.css"
import { Grid2 ,Paper} from '@mui/material'

export  function AboutHeroDesktop() {
  return (
    <Grid2  className="productheadercard " >
    <Grid2 className="image1 info" ></Grid2>
    <Grid2 className="image2 info" ></Grid2>
    <Grid2 className="image3 info" ></Grid2>
    <Grid2 className="image4 info" ></Grid2>
    <Grid2 className="image5 info" ></Grid2>
    <Grid2 className="image6 info" ></Grid2>
    <Grid2 className="image7 info" ></Grid2> 
    <Grid2 className="image8 info" ></Grid2>
    <Grid2 className="image9 info" ></Grid2> 
    </Grid2>
  )
}

